import { Link } from 'react-router-dom';
import { getFeaturedVideos } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

export default function FeaturedVideos() {
  const featured = getFeaturedVideos();

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">精选推荐</h2>
            <p className="text-sm text-foreground-500">编辑团队精心挑选的优质视频内容</p>
          </div>
          <Link
            to="/category/life-record"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer font-medium"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {featured.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}